module.exports = __webpack_public_path__ + "img/logo.cc1f1fb4.jpg";